import { v4 as uuidv4 } from 'uuid';
import { reportData } from './dataReport';

const getAnonyUserId = () => {
  if (typeof window !== 'undefined') {
    const localUUID = localStorage.getItem('UUID');
    if (localUUID) {
      return localUUID;
    } else {
      const uuid = uuidv4();
      reportData(uuid, 'createdAt', String(Date.now()));
      localStorage.setItem('UUID', uuid);
      return uuid;
    }
  }
};

export default getAnonyUserId;
